import { ApiSlice } from "../api/Api";
import { stringify } from "query-string";

interface Response<T> {
  data: T;
  errors: any;
  isSuccessful: boolean;
  pageNumber: number;
  statusCode: number;
  totalItemCount: number;
}

export const workOrderApi = ApiSlice.injectEndpoints({
  endpoints: (build) => ({
    getWorkOrder: build.query<Response<any>, string>({
      query: (id) => `workorder/workorder/${id}`,
      //providesTags: () => [{ type: "WorkOrder" }],
    }),
    getLdapGroups: build.query<Response<any>, void>({
      query: () => {
        const query = {
          size: 10000,
          pageNumber: 0,
          isDeleted: false,
        };

        return `/setting/ldap/get-ldap-groups?${stringify(query)}`;
      },
      //providesTags: () => [{ type: "LdapGroup" }],
    }),
    getWorkOrderCategories: build.query<Response<any>, string>({
      query: (typeId) => {
        const query = {
          size: 10000,
          pageNumber: 0,
          isDeleted: false,
          typeId: typeId,
        };

        return `/workorder/category?${stringify(query)}`;
      },
      //providesTags: () => [{ type: "WorkOrderCategory" }],
    }),
    getWorkOrderComments: build.query<Response<any>, string>({
      query: (workOrderId) => {
        const query = {
          size: 10000,
          pageNumber: 0,
          isDeleted: false,
          workOrderId: workOrderId,
        };

        return `/workorder/comment/get-comment-and-description-list-by-workOrderId?${stringify(
          query
        )}`;
      },
      //providesTags: () => [{ type: "WorkOrderComment" }],
    }),
  }),
});

export const {
  useGetWorkOrderQuery,
  useGetLdapGroupsQuery,
  useGetWorkOrderCategoriesQuery,
  useGetWorkOrderCommentsQuery,
} = workOrderApi;

export const {
  endpoints: {
    getWorkOrder,
    getLdapGroups,
    getWorkOrderCategories,
    getWorkOrderComments,
  },
} = workOrderApi;
